import { useRef, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import type { IBadge } from 'libs/design-system/src/types/Badge/badge';

import type {
  IFooterActionState,
  IFormActionRef,
} from '@app/dashboard/types/innerLayout/profile_details/footer';
import { getMerchantProfileData } from '@app/dashboard/utils/localStorageUtils';
import { getMerchantDetails } from '@app/dashboard/services/inner_layout/profile_details';
import { useIntegrationsStore } from '@app/dashboard/store/integrations';
import { QUERY_KEYS } from '@app/dashboard/constants/query-keys';
import { ACCOUNT_STATUS_BADGE } from '@app/dashboard/constants/settings/profile-details';
import { useSettingsUtils } from '../../../Settings/useSettingsUtils';

import { getAccountStatus } from '../../utils';

import Header from '../../components/shared/Header';
import AccountInfo from '../../components/profileDetails/AccountInfo';
import ContactInfo from '../../components/profileDetails/ContactInfo';
import Footer from '../../components/shared/Footer';

import styles from './ProfileInfo.module.scss';

export const ProfileInfo = () => {
  const { t } = useTranslation();
  const { internalPagesBreadcrumbs } = useSettingsUtils();
  const accountID = getMerchantProfileData().id;
  const footerActionsRef = useRef<IFormActionRef>(null);
  const { methods } = useIntegrationsStore();

  //TODO: will be used when the user can edit the email and save changes, currently it's view only

  // const [footerActions, setFooterActions] = useState<IFooterActionState>({
  //   isLoading: false,
  //   shouldDisabledPrimary: false,
  //   shouldDisabledSecondary: false,
  // });

  // const handlePrimaryAction = () => {
  //   footerActionsRef.current?.handleSaveChanges();
  // };

  // const handleCancelClick = () => {
  //   footerActionsRef.current?.handleCancelChanges();
  // };

  const { data: merchantData } = useQuery({
    queryKey: [QUERY_KEYS.GET_PROFILE_DETAILS, accountID],
    queryFn: () => getMerchantDetails(accountID),
    select: (res) => res.data,
    enabled: !!accountID,
  });

  return (
    <div className={styles['profile-info']}>

      <Header
        title={t('innerLayout.profileDetailsPage.title')}
        subTitle={t('innerLayout.profileDetailsPage.subTitle')}
        breadCrumbs={internalPagesBreadcrumbs.PROFILE_DETAILS}
        badge={
          methods
            ? (ACCOUNT_STATUS_BADGE(t)[getAccountStatus(methods)] as IBadge)
            : {}
        }
      />
      <AccountInfo
        merchantData={merchantData}
        ref={footerActionsRef}
        // setFooterActions={setFooterActions}
      />
      <span className={styles['profile-info__divider']} />
      <ContactInfo phoneNumbers={merchantData?.phones || []} />
      {/* <Footer
        isLoading={footerActions.isLoading}
        shouldDisabledPrimary={footerActions.shouldDisabledPrimary}
        shouldDisabledSecondary={footerActions.shouldDisabledSecondary}
        primaryBtnText={t('innerLayout.profileDetailsPage.actions.saveChanges')}
        handlePrimaryAction={handlePrimaryAction}
        handleCancelChanges={handleCancelClick}
      /> */}
    </div>
  );
};
